<ion-header>
	<app-modal-header-dm (closeModal)="onClose()" [modalTitle]="sharedDataService.dedicatedModeLocationUse?.locationName"></app-modal-header-dm>
</ion-header>

<div class="content">
	<ion-img src="./assets/icon/portrait-mode.png"></ion-img>
	<ion-label>{{ 'PAGESPECIFIC_TEXT.FORM_LIST.PLEASE_ROTATE_DEVICE_TO_PORTRAIT_MODE' | translate }}</ion-label>
</div>
